module.exports = __webpack_public_path__ + "static/img/person.f931337.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/person.png
// module id = ym9M
// module chunks = 1